import { Card, Text } from '@shopify/polaris';

export function SettingsSection({
  title,
  description,
  action,
  children,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Card>
      <div className="admin-settings-section">
        <div className="admin-settings-section__context">
          <Text as="h2" variant="headingMd">{title}</Text>
          {description ? (
            <Text as="p" variant="bodySm" tone="subdued">{description}</Text>
          ) : null}
          {action ? <div className="admin-settings-section__action">{action}</div> : null}
        </div>
        <div className="admin-settings-section__body">
          {children}
        </div>
      </div>
    </Card>
  );
}

export function SettingsFieldRow({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`admin-settings-field-row ${className}`}>{children}</div>;
}
